import { FormBase } from 'core/components';

export default class FinalStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.LABELINGMODE.TRACKINGNUMBER',
					rules: 'required',
				},
			],
		};
	}

	options() {
		return {
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/FinalStepForm.js